import { useEffect, useState } from 'react';

export type UserAgentOS = 'win' | 'mac' | 'linux';

export function useOs() {
  const [os, setOS] = useState<UserAgentOS>('win');

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      const userAgent = window.navigator.userAgent.toLowerCase();

      if (userAgent.includes('win')) {
        return;
      }

      if (userAgent.includes('mac')) {
        setOS('mac');
      } else if (userAgent.includes('linux')) {
        setOS('linux');
      }
    } catch {
      // ignore
    }
  }, []);

  return os;
}
